<template>
  <div id="all-numbers">
    <a ref="blobAnchor" class="d-none"></a>
    <button type="button" class="btn btn-info btn-sm" @click="exportToCsv">
      Export All #'s (by month) Table
      <i class="fa fa-download" />
    </button>
    <div class="table-responsive">
      <table class="table table-striped table-bordered table-hover table-sm">
        <thead class="thead-dark">
          <tr>
            <th v-for="col in columns" :key="col.text" :style="{ 'min-width': (col.width || 'none') }">{{ col.text }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="month in careerByMonths" :key="month.recordId">
            <td>{{ month.recordId }}</td>
            <td>{{ month.calendar }}</td>
            <td>{{ month.ageByMonths }}</td>
            <td>{{ month.ageCompletedYears }}</td>
            <td>{{ month.pebdService }}</td>
            <td>{{ month.pebdPresent }}</td>
            <td>{{ month.pebdCompleted }}</td>
            <td>{{ month.pebdYOSCompleted }}</td>
            <td>{{ month.asdService }}</td>
            <td>{{ month.asdPresent }}</td>
            <td>{{ month.asdCompleted }}</td>
            <td>{{ month.asdYOSCompleted }}</td>
            <td>{{ month.suggestedRank }}</td>
            <td>{{ month.overrideRank }}</td>
            <td>{{ month.component }}</td>
            <td>{{ month.payAmountTodaysDollars }}</td>
            <td>{{ month.payAmountFutureDollars }}</td>
            <td>{{ month.currentPayAmountTodaysDollars }}</td>
            <td>{{ month.currentPayAmountFutureDollars }}</td>
            <td>{{ month.pensionAmountTodaysDollars }}</td>
            <td>{{ month.pensionAmountFutureDollars }}</td>
            <td>{{ month.pensionColaGrowthRate }}</td>
            <td>{{ month.tspServiceMemberContributionAmountTodaysDollars }}</td>
            <td>{{ month.tspServiceMemberContributionMonthlyTotalTodaysDollars }}</td>
            <td>{{ month.tspYearlyRunningTotalAmountTodaysDollars }}</td>
            <td>{{ month.tspIrsYearlyCapLimitTodaysDollars }}</td>
            <td>{{ month.tspServiceMemberBalanceNoGrowthTodaysDollars }}</td>
            <td>{{ month.tspServiceMemberGrowthAmountTodaysDollars }}</td>
            <td>{{ month.tspServiceMemberWithdrawalTodaysDollars }}</td>
            <td>{{ month.tspServiceMemberBalanceTodaysDollars }}</td>
            <td>{{ month.tspServiceMemberContributionAmountFutureDollars }}</td>
            <td>{{ month.tspServiceMemberContributionMonthlyTotalFutureDollars }}</td>
            <td>{{ month.tspYearlyRunningTotalAmountFutureDollars }}</td>
            <td>{{ month.tspIrsYearlyCapLimitFutureDollars }}</td>
            <td>{{ month.tspServiceMemberBalanceNoGrowthFutureDollars }}</td>
            <td>{{ month.tspServiceMemberGrowthAmountFutureDollars }}</td>
            <td>{{ month.tspServiceMemberWithdrawalFutureDollars }}</td>
            <td>{{ month.tspServiceMemberBalanceFutureDollars }}</td>
            <td>{{ month.activeDutyDays }}</td>
            <td>{{ month.inactiveDutyDaysPaid }}</td>
            <td>{{ month.inactiveDutyDaysNonPaid }}</td>
            <td>{{ month.membershipPoints }}</td>
            <td>{{ month.payPoints }}</td>
            <td>{{ month.retirementPoints }}</td>
            <td>{{ month.serviceYearPoints }}</td>
            <td>{{ month.goodYear }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="serviceMember.currentComponent === 'reserve' || serviceMember.endingComponent === 'reserve'">
      <div>
        Active duty days (inferred): {{ serviceMember.results.reserveComponent.inferredActiveDutyDays }}
      </div>
      <div>
        Good years (inferred): {{ serviceMember.results.reserveComponent.inferredGoodYears }}
      </div>
      <div>
        Retirement point (inferred): {{ serviceMember.results.reserveComponent.inferredRetirementPoints }}
      </div>
    </div>
    <div>
      <more-info :moreInfo="moreInfo.allNumbers" @click="moreInfoOpen" />
    </div>
  </div>
</template>

<script>
import AllNumbersMixin from '@/js/mixins/calculator/results/all-numbers/all-numbers-mixin';

export default {
    mixins: [AllNumbersMixin],
    data() {
      const data = AllNumbersMixin.data();
      return data;
    },
    methods: {
      getCsvRowData(month) {
        const rowData = AllNumbersMixin.methods.getCsvRowData.call(this, month);
        return rowData;
      }
    },
};
</script>

<style scoped lang="scss">
  #all-numbers {
    table {
      font-size: 8pt;

      th, td {
        text-align: center;
      }

      th {
        position: sticky;
        top: -1px;
        background-color: #444343;
        color: #ffffff;
      }
    }

    .table-hover tbody tr:hover td {
      background-color: #808080;
      color: #4cff00;
      cursor: pointer;
    }
  }

  .table-responsive {
    margin-top: 10px;
    max-height: 500px;
  }
</style>
